import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-action-fixture",
    styleUrls: ["./action-fixture.component.scss"],
    templateUrl: "./action-fixture.component.html"
})
export class FUIActionFixtureComponent {
}
